export type Type = {
	searchTerm: string;
	showAdvancedSearch: boolean;
};

export function create(showAdvancedSearch: boolean): Type {
	return {
		searchTerm: '',
		showAdvancedSearch: showAdvancedSearch,
	};
}

export function setSearchTerm(state: Type, input: string): Type {
	return { ...state, searchTerm: input };
}

export function toggleShowAdvancedSearch(state: Type): Type {
	return { ...state, showAdvancedSearch: !state.showAdvancedSearch };
}
